const {
  getIsLeasingJourneySelected,
} = require("./getIsLeasingJourneySelected");

/**
 * Resolves the automatic (no promo code) discount for the selected journey.
 *
 * APP-35040 - `promoAmount` was introduced as a cash-only discount (APP-10213).
 * Finance (leasing) journeys have their own `promoAmountFinance`, which defaults
 * to 0 so markets without it keep finance prices undiscounted.
 *
 * @param {string} journey - selected journey (JOURNEY_TYPE)
 * @param {Object} configuration - app configuration
 * @returns {number} discount amount incl. tax
 */
function getPromoAmount(journey, configuration) {
  if (getIsLeasingJourneySelected(journey)) {
    return configuration?.promoAmountFinance ?? 0;
  }

  return configuration?.promoAmount ?? 0;
}

module.exports = {
  getPromoAmount,
};
